import * as React from "react";
import { Grid, Dialog } from "@mui/material";
import { TextInput, useRecordContext, required } from "react-admin";
import { DialogueContext } from "../../../Components/ActionsMenu";
import { CreateForm } from "../../../Layout/CreateForm";

export const RechargeForm = ({ handleClose, record }) => {
  const validateAmount = (value) => {
    if (!value) return "Required";
    if (!/^\d+(\.\d{1,2})?$/.test(value)) {
      return "Amount must be a positive number with up to 2 decimal places";
    }
    if (parseInt(value, 10) <= 0) return "Amount must be greater than zero";
    if (value > record?.balance)
      return `Amount cannot exceed (${record?.balance?.toFixed(2)})`;
    return undefined;
  };

  return (
    <CreateForm
      title="Redeem User"
      handleClose={handleClose}
      record={record}
      resource="redeemRecords"
    >
      <Grid item xs={12}>
        <TextInput
          id="username"
          source="username"
          name="username"
          label="Account"
          readOnly
          fullWidth
        />
      </Grid>
      <Grid item xs={12}>
        <TextInput
          id="txn_type"
          source="txn_type"
          name="txn_type"
          label="Redeem"
          defaultValue="Redeem"
          readOnly
          fullWidth
        />
      </Grid>
      <Grid item xs={12}>
        <TextInput
          id="amount"
          name="amount"
          label="Redeem Amount"
          fullWidth
          validate={[required(), validateAmount]}
          onInput={(e) => {
            const value = e.target.value;

            // Allow only numbers and a single dot
            let sanitized = value.replace(/[^0-9.]/g, "");

            // Prevent multiple dots
            const parts = sanitized.split(".");
            if (parts.length > 2) {
              sanitized = parts[0] + "." + parts[1];
            }

            // Restrict to 2 decimal places
            if (parts[1]?.length > 2) {
              sanitized = parts[0] + "." + parts[1].slice(0, 2);
            }

            e.target.value = sanitized;
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              e.stopPropagation();
            }
          }}
        />
      </Grid>

      <div
        style={{
          backgroundColor: "rgba(30, 30, 30, 0.5)",
          padding: "5px",
          borderRadius: "3px",
          marginBottom: "5px",
        }}
      >
        <span
          style={{
            color: "#FFD700",
            fontWeight: "bold",
            fontSize: "0.75em",
          }}
        >
          Maximum Amount Redeem: {record?.balance?.toFixed(2)}
        </span>
      </div>
      <Grid item xs={12}>
        <TextInput id="remarks" name="remarks" label="Remark" fullWidth    onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  e.stopPropagation();
                }
              }}/>
      </Grid>
    </CreateForm>
  );
};

export const RedeemBalanceFormDialog = ({ openDialog, handleDialogClose }) => {
  const { handleMenuClose } = React.useContext(DialogueContext);
  const handleClose = () => {
    handleDialogClose();
    handleMenuClose();
  };
  const record = useRecordContext();
  return (
    <Dialog
      open={openDialog}
      onClose={handleClose}
      onKeyDown={(evt) => evt.stopPropagation()}
    >
      <RechargeForm handleClose={handleClose} record={record} />
    </Dialog>
  );
};
